import React, { useState, useEffect } from "react";
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: ""
  });

  const [statusMessage, setStatusMessage] = useState('');

  useEffect(() => {
    if (statusMessage === 'Message Sent Successfully! ✅' || statusMessage.includes('Failed')) {
      const timer = setTimeout(() => {
        setStatusMessage('');
      }, 5000); // Clear message after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Reset status and indicate sending
    setStatusMessage('Sending...');

    const templateParams = {
      to_name: "Admin", 
      from_name: formData.fullName, 
      from_email: formData.email,
      message: formData.message, 
    };

    emailjs.send(
      process.env.REACT_APP_SERVICE_ID,
      process.env.REACT_APP_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_USER_ID // This is the Public Key
    )
    .then((result) => {
      console.log('EmailJS Success:', result.text);
      setStatusMessage('Message Sent Successfully! ✅');
      
      // Success Alert
      alert("Form submitted! (Email sent successfully)");
      
      // Clear the form after successful submission
      setFormData({ fullName: "", email: "", message: "" });
    }, (error) => {
      console.log('EmailJS Failed:', error.text);
      setStatusMessage('Failed to send message. Please try again. ❌');
      
      // Failure Alert (Optional)
      // alert("Form submission failed!");
    });
  };

  return (
    <div className="form-container" id="contact us">
      <div className="heading-section">
        <h1 className="form-title">Contact Form</h1>
        <p className="form-sub-title">Leave a message to book an appointment or notify us of your interest.</p>
      </div>
      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          className="form-field"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          className="form-field"
          required
        />
        <textarea
          name="message"
          placeholder="Your message"
          value={formData.message}
          onChange={handleChange}
          className="form-field"
          style={{ height: "20vh" }}
          required
        />
        <button type="submit" className="submit-button" disabled={statusMessage === 'Sending...'}>
          {statusMessage === 'Sending...' ? 'Sending...' : 'Submit'}
        </button>
      </form>

      {/* Status Message Display */}
      {statusMessage && <p className="status-message" style={{ textAlign: "center" }}>{statusMessage}</p>}
      
    </div>
  );
};

export default ContactForm;